import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO: remove this component in Currency v2
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { InputGroup } from '../InputGroup/InputGroup';
import { Input } from './Input';
export var getErrorFromValidation = function getErrorFromValidation(validation) {
  return validation && validation.isValid === false;
};
export var getHelpFromValidation = function getHelpFromValidation(validation) {
  var error = getErrorFromValidation(validation);

  if (error && Array.isArray(validation.feedback)) {
    return /*#__PURE__*/React.createElement("span", null, validation.feedback.map(function (feedback, index) {
      return /*#__PURE__*/React.createElement("span", {
        // eslint-disable-next-line react/no-array-index-key
        key: "validation-feedback-".concat(index),
        className: classes('display-block') // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      });
    }));
  }

  return null;
};
/**
 * This component provides the same API as the <Input> component before v9.
 * It's meant as a backwards-compatibility "shim" to make upgrading easier.
 *
 * This is a combination of Input and InputGroup. You should eventually
 * migrate to using Input and InputGroup separately yourself.
 */

export var LegacyInput = function LegacyInput(_ref) {
  var id = _ref.id,
      label = _ref.label,
      validation = _ref.validation,
      icon = _ref.icon,
      inputComponent = _ref.inputComponent,
      otherProps = _objectWithoutProperties(_ref, ["id", "label", "validation", "icon", "inputComponent"]);

  var InputComponent = inputComponent;
  return /*#__PURE__*/React.createElement(InputGroup, {
    label: label,
    error: getErrorFromValidation(validation),
    help: getHelpFromValidation(validation),
    inputId: id,
    input: /*#__PURE__*/React.createElement(InputComponent, _extends({
      id: id,
      icon: icon,
      error: getErrorFromValidation(validation),
      fullWidth: true
    }, otherProps))
  });
};
LegacyInput.defaultProps = {
  inputComponent: Input
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  LegacyInput.propTypes = {
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    id: PropTypes.string,

    /*
     * validation object has the following structure:
     *   isValid: true/false based on if there is an error state
     *   errors: array of error strings, separate from error display messages
     *   feedback: array of error strings, which are intended to be displayed to the user.
     *     HTML can be passed in, so a valid error string is "Please enter a <b>number</b>"
     */
    validation: PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    type: PropTypes.string,
    pattern: PropTypes.string,
    className: PropTypes.string,
    maxLength: PropTypes.number,
    icon: PropTypes.node,
    inputComponent: PropTypes.any // eslint-disable-line react/forbid-prop-types

    /**
     * Any further props will be passed to the <Input> component.
     */

  };
}

export { // Backwards compatibility, remove in next semver-major
getHelpFromValidation as getFeedbackFromValidation };